export default __webpack_public_path__ + "static/media/scale.e2ac22c5.svg";